module DataAttributeTools
{
	export function DataForElementOrParents(element: JQuery<HTMLElement>, key: string): any
	{
		if (element.data(key))
		{
			return element.data(key);
		}
		
		return element.parents(`[data-${key}]`).data(key);
	}
}